import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Invoice, Plan, usePayInvoice, usePaymentMethod } from '@app/api';
import { useToast, InformationBox, SubmitButton } from '@app/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmitButtonsLine, Toggle } from 'components';
import { PaymentMethodBlock } from 'components/BillingInformation/PaymentMethodBlock';
import { Form, Formik } from 'formik';
import { AxiosError } from 'axios';

const useStyles = createUseStyles((theme: Theme) => ({
  buttons: {
    marginTop: theme.marginBase * 2,
  },
}));

interface Props {
  invoice: Invoice;
  plan?: Plan;
}

export const ChargeCardForm = ({ invoice, plan }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const toast = useToast();

  const { data: paymentMethod } = usePaymentMethod(plan?.paymentMethodId);
  const [paymentError, setPaymentError] = useState<string | null>(null);
  const { mutateAsync: payInvoice } = usePayInvoice(invoice.id);

  const chargeCard = async ({
    shouldSendEmail,
  }: {
    shouldSendEmail: boolean;
  }) => {
    try {
      setPaymentError(null);
      await payInvoice({
        paymentMethodId: plan?.paymentMethodId,
        shouldSendEmail,
      });
    } catch (e) {
      const { response } = e as AxiosError<{ message?: string }>;
      if (response?.data?.message) {
        setPaymentError(response.data.message);
      }
      toast.exception(e);
    }
  };

  return (
    <Formik initialValues={{ shouldSendEmail: true }} onSubmit={chargeCard}>
      <Form>
        <PaymentMethodBlock paymentMethod={paymentMethod} />
        {paymentError && (
          <InformationBox text={paymentError} variant="danger" />
        )}
        <Toggle
          name="shouldSendEmail"
          label={t('admin.billing.invoicing.sendPaidInvoiceEmail')}
        />
        <SubmitButtonsLine className={classes.buttons}>
          <SubmitButton
            text={t('admin.billing.invoicing.chargeCard')}
            small
          />
        </SubmitButtonsLine>
      </Form>
    </Formik>
  );
};
